import React from 'react';
import { Calendar, Clock } from 'lucide-react';

interface ScheduleSettingsProps {
  scheduledDate: string;
  scheduledTime: string;
  onDateChange: (date: string) => void;
  onTimeChange: (time: string) => void;
  disabled?: boolean;
  platformName?: string;
}

export default function ScheduleSettings({
  scheduledDate,
  scheduledTime,
  onDateChange,
  onTimeChange,
  disabled = false,
  platformName = ''
}: ScheduleSettingsProps) {
  const isScheduled = scheduledDate || scheduledTime;

  return (
    <div className="border-t pt-4">
      <div className="flex items-center justify-between mb-3">
        <h4 className="text-sm font-semibold text-gray-700">
          Schedule {platformName} Post
        </h4>
        {isScheduled && (
          <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded-full">
            Scheduled
          </span>
        )}
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="relative">
          <label className="block text-xs font-medium text-gray-600 mb-1">
            <Calendar className="inline w-3 h-3 mr-1" />
            Date
          </label>
          <input
            type="date"
            value={scheduledDate}
            onChange={(e) => onDateChange(e.target.value)}
            disabled={disabled}
            className="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
            min={new Date().toISOString().split('T')[0]}
          />
        </div>

        <div className="relative">
          <label className="block text-xs font-medium text-gray-600 mb-1">
            <Clock className="inline w-3 h-3 mr-1" />
            Time
          </label>
          <input
            type="time"
            value={scheduledTime}
            onChange={(e) => onTimeChange(e.target.value)}
            disabled={disabled}
            className="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
          />
        </div>
      </div>

      {isScheduled && (
        <p className="mt-2 text-xs text-gray-500">
          Post will be published on{' '}
          {new Date(`${scheduledDate} ${scheduledTime}`).toLocaleString(undefined, {
            dateStyle: 'medium',
            timeStyle: 'short'
          })}
        </p>
      )}
    </div>
  );
}